



import Component from 'vue-class-component';
import Footer from '@/components/footer/footer.component.ts';

@Component
export default class SurlFooter extends Footer {
}

